// # #############################################
// # Title : Landing Page
// # Authors : Dhruv, Shubham, Atul
// # Date : 15th October 2019
// # Last Modified : Dhruv, September 2019
// # Version : 19.10.03
// # Description : This is the code for the Landing page
// # ############################################

import React, { Component } from 'react';
import GlobalEvents from "../utils/global-events";
import OpenScenarioDialogue from './OpenScenarioDialogue';
import config from "../utils/config";
import ScenarioWizard from './ScenarioWizard';
import Paper from '@material-ui/core/Paper';
import Fab from '@material-ui/core/Fab';
import '../css/Landing.css';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
class Landing extends Component {
    state = {
        openDrawer: false,
        showLogoutbutton: false,
        redirectFlag: 0,
        rows: [],
        accessDenied: false,
        showDeniedPopup: false
    }

    componentDidMount() {
        GlobalEvents.on('handleScenario', this.handleScenario.bind(this))

    }

    handleScenario(e) {

        if (e === 3) {
            this.props.showNotification("Coming soon !", { variant: "information" })
        }
        else if (e === 1 && config.username === "realgames") {
            // this.props.showNotification("Access denied. Contact Delivery.Engine.Support@mu-sigma.com", { variant: "warning" })
            this.setState({
                accessDenied: true,
                showDeniedPopup: true
            })
        }
        else {
            this.setState({
                redirectFlag: e
            })
        }
    }

    toCountry() {
        GlobalEvents.trigger("triggercountry", 'usa');
    }

    drawerOpen = () => {
        this.setState({
            openDrawer: true,
        })
    }

    handleClose = () => {
        this.setState({
            showDeniedPopup: false
        })
    }

    accessDenied() {
        return (
            <Dialog
                open={this.state.showDeniedPopup}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Creation Access Denied"}
                    <img style={{
                        "width": "4%",
                        "padding": "0% 1%",
                        "vertical-align": "top"
                    }}
                        alt="" src="warningIcon.png" />
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Access to create a scenario is restricted. You are free to explore existing scenarios. For further support reach out to <br /><i><b>Delivery.Engine.Support@mu-sigma.com</b></i>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose} color="primary">
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    getLandingPage() {
        let flag = this.state.redirectFlag;
        const cardLabel = ["Create a Scenario", "Open a Scenario", "Compare Scenario"];
        const cardContent = ["Create a Scenario for running a simulation",
            "Open an existing Scenario which is either running or completed",
            "Compare existing Scenarios"];
        const buttonLabel = ["Create Scenario", "Open Scenario", "Compare Scenario"];
        const cardIcon = ["createScenario.svg", "openScenario.svg", "compareScenario.svg"]

        return (
            <React.Fragment>
                {flag === 1 ? <ScenarioWizard showNotification={this.props.showNotification} /> : null}
                {flag === 2 ? <OpenScenarioDialogue showNotification={this.props.showNotification} switchPannel={(d) => this.handleScenario(d)} /> : null}
                {this.state.accessDenied === true ? this.accessDenied() : null}
                <div>
                    <div onClick={() => this.drawerOpen.bind(this)} style={{ position: 'fixed', marginTop: 'calc( 1vw + 1vh )' }}>
                        <img src="homeWithPlaceholder.svg" alt="hometabplaceholder" style={{ height: 'calc( 3vw + 3vh )' }}></img>
                    </div>
                </div>
                <div
                    className="scenarioPaper"
                    style={{
                        display: "flex",
                        width: "100%",
                        textAlign: "-webkit-center",
                        position: "absolute",
                        left: "16%",
                        marginTop: "10%"
                    }}
                >

                    {
                        ([1, 2, 3]).map((d) => (
                            <div style={{ marginLeft: "5%" }}>
                                <Paper style={{ height: "16vw", minWidth: "100px", width: "14vw", padding: "6%", display: "grid", fontFamily: "inherit" }}>
                                    <img src={cardIcon[d - 1]} alt={cardLabel[d - 1]} style={{ width: '6vw', marginTop: '2%' }}></img>
                                    <text style={{ marginBottom: "0%", fontSize: "1vw", fontWeight: "600" }}>{cardLabel[d - 1]}</text>
                                    <text style={{ opacity: "0.6", fontSize: "0.8vw" }}>{cardContent[d - 1]}</text>
                                </Paper>
                                <Fab variant="extended"
                                    className="baseButton"
                                    color="secondary"
                                    onClick={this.handleScenario.bind(this, d)}
                                    aria-label="delete" > {buttonLabel[d - 1]} </Fab>
                            </div>
                        ))
                    }
                </div>
            </React.Fragment>
        )
    }



    showLogout = (e) => {
        this.setState({
            showLogoutbutton: !this.state.showLogoutbutton
        })
    }

    splitWord(username) {
        return username.replace(".", " ")
    }

    getCreateScenario() {
        return <text style={{ opacity: "0.6", fontSize: "14px" }}>Open an existing Scenario which is either running or completed</text>
    }
    render() {
        return (
            <React.Fragment>
                {this.getLandingPage()}
            </React.Fragment>
        );
    }
}

export default Landing;